import { theme } from "../theme/theme"

export function randomThemeColor() {
  const colorfulTheme = {
    primary: theme.colors.primary,
    secondary: theme.colors.secondary,
    accent1: theme.colors.accent1,
    // accent2: theme.colors.accent2,
    accent3: theme.colors.accent3,
    accent4: theme.colors.accent4,
    // extra1: theme.colors.extra1,
    // extra2: theme.colors.extra2,
    // extra3: theme.colors.extra3,
    // extra4: theme.colors.extra4,
  }

  var keys = Object.keys(colorfulTheme)
  return colorfulTheme[keys[(keys.length * Math.random()) << 0]]
}
